'use client'

import { PropsWithChildren, useCallback, useMemo, useReducer, useRef, useState } from 'react'

import { ClientDataComponentIdentifier } from './types'
import ClientDataComponentContext from './ClientDataComponentContext'

const ClientDataComponentProvider = (props: PropsWithChildren) => {
  const elements = useRef(new Map<ClientDataComponentIdentifier, HTMLElement>())
  const [, reRender] = useReducer(counter => counter + 1, 0)

  const [hiddenFallbackIds, setHiddenFallbackIds] = useState<ReadonlyArray<string>>([])

  const getElement = useCallback(
    (id: ClientDataComponentIdentifier) => elements.current.get(id) ?? null,
    [],
  )

  const setElement = useCallback(
    (id: ClientDataComponentIdentifier, element: HTMLElement | null) => {
      if (!element) return
      if (elements.current.has(id)) return

      elements.current.set(id, element)
      reRender()
    },
    [],
  )

  const value = useMemo(
    () => ({ getElement, setElement, hiddenFallbackIds, setHiddenFallbackIds }),
    [getElement, setElement, hiddenFallbackIds, setHiddenFallbackIds],
  )

  return <ClientDataComponentContext.Provider {...props} value={value} />
}

export default ClientDataComponentProvider
